module.exports = __webpack_public_path__ + "static/media/iconLost-final.d4605d69.svg";